;(function () {
  function slideUp(el, duration) {
    el.style.overflow = 'hidden';
    el.style.transition = 'height ' + duration + 'ms ease';
    el.style.height = el.offsetHeight + 'px';
    requestAnimationFrame(function () { el.style.height = '0px'; });
    setTimeout(function () {
      el.style.display = 'none'; el.style.height = ''; el.style.transition = ''; el.style.overflow = '';
    }, duration);
  }

  function slideDown(el, duration) {
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.transition = 'height ' + duration + 'ms ease';
    var h = el.scrollHeight;
    requestAnimationFrame(function () { el.style.height = h + 'px'; });
    setTimeout(function () {
      el.style.height = ''; el.style.transition = ''; el.style.overflow = '';
    }, duration);
  }

  function initCollapsibleContent() {
    document.querySelectorAll('.collapsible-content__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var parent = toggle.parentElement;
        var answer = toggle.nextElementSibling;
        if (!answer || !answer.classList.contains('collapsible-content__answer')) return;

        if (!parent.classList.contains('active')) {
          var activeItem = parent.parentElement.querySelector('.collapsible-content__item.active');
          if (activeItem) {
            activeItem.classList.remove('active');
            var sa = activeItem.querySelector('.collapsible-content__answer');
            if (sa) slideUp(sa, 300);
          }
          parent.classList.add('active');
          slideDown(answer, 300);
        } else {
          parent.classList.remove('active');
          slideUp(answer, 300);
        }
      });
    });
  }

  function handleResize() {
    document.querySelectorAll('.collapsible-content__answer').forEach(function (a) { a.removeAttribute('style'); });
    document.querySelectorAll('.collapsible-content__item.active .collapsible-content__answer').forEach(function (a) {
      a.style.display = 'block';
    });
  }

  window.addEventListener('resize', handleResize);
  document.addEventListener('shopify:section:load', function () { initCollapsibleContent(); handleResize(); });
  initCollapsibleContent();
  handleResize();
})();
